import { bookServiceApi } from '@/services/api';

export interface ChapterAskRequest {
  question: string;
}

export interface ChapterAskResponse {
  answer: string;
  detail?: string;
  is_premium?: boolean;
  remaining_requests?: number;
  gems_info?: {
    previous_gems: number;
    new_gems: number;
    gems_used: boolean;
  };
}

export const askChapter = async (
  chapterId: number,
  payload: ChapterAskRequest
): Promise<ChapterAskResponse> => {
  const res = await bookServiceApi.post<ChapterAskResponse>(`/chapters/${chapterId}/ask`, payload);
  // Return response even if it has detail (error message) - let caller handle it
  if (res.success && res.data) return res.data;
  // Also return data if it contains detail and remaining_requests (insufficient gems case)
  if (res.data?.detail !== undefined && res.data?.remaining_requests !== undefined) {
    return res.data;
  }
  throw new Error(res.error || 'خطا در جواب دادن سوال');
};
